// ─── Universal Starter V1 ─────────────────────────────────────
// Blank canvas template. Three empty sections for the user to
// build their invitation from scratch with drag/drop.

export const universalStarterV1 = {
  templateId: 'universal-starter-v1',
  name: 'Blank Canvas',
  description: 'Start from scratch. Add sections, upload images, style everything your way.',
  category: 'universal',
  previewColors: ['#f8f8f8', '#333333', '#c8a96b'],
  isCollage: true,
  isUniversal: true,
  theme: {
    palette: 'ivory-gold',
    fontPair: 'playfair-inter',
    radius: 'soft',
    shadow: 'soft',
    overlay: 'none',
    themeExtensions: {
      paper: '#ffffff',
      monoFont: '"Courier New", monospace',
      handFont: '"Caveat", cursive',
    },
  },
  settings: {
    rsvpEnabled: true,
  },
  sections: [
    {
      id: 'hero-1',
      type: 'collage',
      label: 'Hero',
      visible: true,
      height: { mobile: 700, desktop: 800 },
      background: { type: 'color', color: '#f5f0eb' },
      editableRules: { fields: ['elements', 'background', 'height'], locked: [] },
      data: {},
      elements: [],
    },
    {
      id: 'content-1',
      type: 'collage',
      label: 'Content',
      visible: true,
      height: { mobile: 900, desktop: 800 },
      background: { type: 'color', color: '#ffffff' },
      editableRules: { fields: ['elements', 'background', 'height'], locked: [] },
      data: {},
      elements: [],
    },
    {
      id: 'footer-1',
      type: 'collage',
      label: 'Footer',
      visible: true,
      height: { mobile: 300, desktop: 400 },
      background: { type: 'color', color: '#f5f0eb' },
      editableRules: { fields: ['elements', 'background', 'height'], locked: [] },
      data: {},
      elements: [],
    },
  ],
};
